import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  IOnuSyncPreview,
  IOnuView,
  OnuSyncField,
  OnuAction,
  OnuReadResource,
} from '@modules/clients/services/olt/models/onu-view.model';
import { IResponse } from '@sharedModels/response-pagination.model';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

/**
 * Pantalla onu/view de SmartOLT a través del backend (smart-olt/onu-view).
 */
@Injectable({
  providedIn: 'root',
})
export class OnuViewService {
  private readonly baseUrl = `${environment.apiUrl}/smart-olt/onu-view`;

  constructor(private readonly http: HttpClient) {}

  /**
   * resolveOnuId: id interno de SmartOLT a partir del SN
   */
  public resolveOnuId(sn: string) {
    return firstValueFrom(
      this.http.get<IResponse<{ onuId: number }>>(`${this.baseUrl}/resolve/${sn}`),
    );
  }

  /**
   * getView
   */
  public getView(onuId: number) {
    return firstValueFrom(this.http.get<IResponse<IOnuView>>(`${this.baseUrl}/${onuId}`));
  }

  /**
   * read: lecturas de estado, gráficos, historial, notas y opciones de los formularios
   */
  public read<T = any>(
    onuId: number,
    resource: OnuReadResource,
    params: Record<string, string | number> = {},
  ) {
    return firstValueFrom(
      this.http.get<IResponse<T>>(`${this.baseUrl}/${onuId}/read/${resource}`, { params }),
    );
  }

  /**
   * action: ediciones y acciones sobre la ONU
   */
  public action<T = any>(onuId: number, action: OnuAction, body: Record<string, unknown> = {}) {
    return firstValueFrom(
      this.http.post<IResponse<T>>(`${this.baseUrl}/${onuId}/action/${action}`, body),
    );
  }

  /**
   * syncPreview: datos del cliente y contrato frente a los de SmartOLT (no modifica nada)
   */
  public syncPreview(onuId: number) {
    return firstValueFrom(
      this.http.get<IResponse<IOnuSyncPreview>>(`${this.baseUrl}/${onuId}/sync`),
    );
  }

  /**
   * syncApply: copia a SmartOLT los datos elegidos
   */
  public syncApply(onuId: number, fields: OnuSyncField[]) {
    return firstValueFrom(
      this.http.post<IResponse<{ applied: OnuSyncField[] }>>(`${this.baseUrl}/${onuId}/sync`, {
        fields,
      }),
    );
  }
}
